import { Component, ElementRef, HostListener, OnInit, ViewChild, ViewContainerRef, ComponentFactoryResolver, ChangeDetectorRef, NgZone } from '@angular/core';
import { GlobalServices } from '../global.services';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../api.service';
import { baseUrls } from '../appConstant';
import { Router } from '@angular/router';
import { SubscriptionPlanService } from '../services/subscription-plan.service';
declare var $: any;
declare var gapi: any;

@Component({
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  @ViewChild('loginRef', { static: true }) loginElement: ElementRef;
  public clickcheck = 0;
  public auth2: any;
  loginForm: FormGroup;
  submitted: boolean;
  errorMsg: string = '';
  wrongPassword: string = '';
  forgotPassword: boolean = true;
  userEmail: string;
  responseData: any = {};
  mode: string;
  color: any = 'primary';
  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.globalServices.isBrowser) {
      if (!document.getElementById('signin-wrap').contains(event.target) && this.clickcheck !== 0) {
        this.globalServices.viewcontainerhelper.clear();
        this.clickcheck = 0;
      } else {
        this.clickcheck = 1;
      }
    }
  }

  constructor(public globalServices: GlobalServices, private httpService: ApiService, private formBuilder: FormBuilder, public cfr: ComponentFactoryResolver, private viewContainerRef: ViewContainerRef,
    private router: Router,
    private cd: ChangeDetectorRef,
    private ngZone: NgZone,
    private subscriptionPlanService: SubscriptionPlanService) { }

  ngOnInit(): void {
    if (this.globalServices.isBrowser) {
      this.loginForm = this.formBuilder.group({
        email: [localStorage.getItem("userEmail") || "", Validators.required],
        password: [localStorage.getItem("userPass") || "", Validators.required],
      });
      this.loginForm.reset();
      this.isRegisterPage = this.router.url?.includes("register") ? true : false;
    }
  }
  isRegisterPage = false;
  get signinFormData() {
    return this.loginForm.controls;
  }

  ssoLogin() {
    let url = "/xyz";
    let data = "{ type: 'google'}";

    this.httpService.postFormData(url, data).subscribe(response => {
      if (response.success) {
        this.errorMsg = '';
        this.wrongPassword = '';
        if (this.globalServices.isBrowser) {
          localStorage.setItem('userDetails', JSON.stringify(response['data']));
          localStorage.setItem('userToken', response['token']);
        }
      } else {
        if (response['statusCode'] == '03') {
          this.errorMsg = response['message'];
        } else {
          this.wrongPassword = response['message'];
        }
      }
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.loginForm.invalid) {
      return;
    } else {
      let data = { email: this.loginForm.value.email, password: this.loginForm.value.password, type: 'normal' };
      if (this.globalServices.isBrowser) {
        if (this.globalServices.cameFrom === 'Partners') {
          let url = "vendor/login";
          this.httpService.postFormData(url, data).subscribe(response => {
            if (response.success) {
              this.errorMsg = '';
              this.wrongPassword = '';
              if (this.globalServices.isBrowser) {
                localStorage.setItem('userDetails', JSON.stringify(response['data']));
                localStorage.setItem('userToken', response['token']);
              }
            } else {
              if (response['statusCode'] == '03') {
                this.errorMsg = response['message'];
              } else {
                this.wrongPassword = response['message'];
              }
            }
          });
        }
        else {
          try {
            this.mode = 'indeterminate';
            let url = "user/login";
            localStorage.setItem("userEmail", this.loginForm.value.email);
            localStorage.setItem("userPass", this.loginForm.value.password);

            this.httpService.postFormData(url, data).subscribe(response => {
              if (response.success) {
                this.globalServices.isLoggedIn = true;

                response['data']['siteUrl'] = response['siteUrl'];

                localStorage.setItem('userDetails', JSON.stringify(response['data']));
                localStorage.setItem('userToken', response['token']);
                this.globalServices.userDetails = JSON.parse(JSON.stringify(response['data']));
                this.getUserCurrentPlan();
                if (response['isSubscriptionPurchased']) {
                  localStorage.setItem('isSubscriptionPurchased', JSON.stringify(response['isSubscriptionPurchased']));
                }
                if (response?.data?.timezone) {
                  localStorage.setItem('timezone', JSON.stringify(response['data']["timezone"]));
                }
                if (JSON.parse(localStorage.getItem('cartdata')) !== null) {
                  let datum = [];
                  var a = [];
                  a = JSON.parse(localStorage.getItem('cartdata'));
                  a.forEach(el => {
                    let date = el.date?.split('-');
                    let dat = {
                      type: el.portal,
                      productId: el.programId,
                      productInfo: {
                        bookingStartDate: date && date[0] ? date[0] : new Date(),
                        bookingEndDate: date && date[1] ? date[1] : new Date(),
                        accommodationId: el.accommodationId,
                        noOfPeople: el.people,
                        addonsId: el.totalAddonsId,
                      },
                      pay: el.payStatus
                    };
                    datum.push(dat);
                  });
                  const headerDict = {
                    token: localStorage.getItem('userToken')
                  };
                  let newdatum = { data: datum };

                  let Url = "billingservice/cartservice/create";
                  this.httpService.postFormDataBilling(Url, newdatum, headerDict).subscribe(response1 => {
                    localStorage.removeItem('cartdata');
                    localStorage.setItem('cartquantity', String(response1.count - 1));
                    this.globalServices.cartquantity = Number(response1.count);
                    if (this.globalServices.priceCheck) {
                    }
                    else if (this.globalServices.signupPage['show']) {
                      this.globalServices.signupTriggerForSignupPage.next(true);
                    } else {
                      this.globalServices.signupStatus = true;
                    }
                  });
                }
                else {
                  localStorage.setItem('cartquantity', String(response.count - 1));
                  this.globalServices.cartquantity = Number(response.count);
                  if (this.globalServices.priceCheck) {
                  } else if (this.globalServices.signupPage['show']) {
                    this.globalServices.signupTriggerForSignupPage.next(true);
                  } else {
                    this.globalServices.signupStatus = true;
                  }
                }
                this.loginForm.reset();
                let userDetails = JSON.parse(localStorage.getItem("userDetails"));
                this.globalServices.firstname = userDetails ? userDetails.firstName : '';
                this.globalServices.imgSrc = userDetails && userDetails['images'] && userDetails['images']['path'] ? baseUrls['images'] + userDetails['images']['path'] + userDetails['images']['name'] : 'assets/images/profile-picture.png';
                this.globalServices.subjectTriggerForLoginDetectAtHeader.next(true);
                this.globalServices.viewcontainerhelper.clear();
                this.globalServices.isActivePlanUserHave();
                this.globalServices?.getSubscriptionPlan();
              }
              else {
                this.wrongPassword = response['message'];
                if (response['statusCode'] == '03') {
                  this.errorMsg = response['message'];
                } else {
                  this.wrongPassword = response['message'];
                }
                this.cd.detectChanges();
              }
              this.mode = 'determinate';
            },
              (error) => {
                this.mode = 'determinate';
                console.log("ErrorInLogin", error);
                this.errorMsg = error['message'] ? error['message'] : "Something bad happened. Please try again ";
              });

          }
          catch (error) {
            this.mode = 'determinate';
            console.log("ErrorInLogin", error);
          }
        }
      }
    }
  }

  public keyUp(event): void {
    if (this.submitted && event.target.value.length == 0) {
      this.wrongPassword = '';
      this.responseData.message = '';
    }
  }

  public forgotPasswordClick() {
    this.globalServices.triggerforgotpassNew(this.globalServices.viewcontainerhelper, this.cfr);
  }

  closecomponent(): void {
    this.globalServices.viewcontainerhelper.clear();
  }

  closecomponentandsignup() {
    this.globalServices.triggersignup(this.globalServices.viewcontainerhelper, this.cfr);
  }

  facebooklogin() {
    if (this.globalServices.isBrowser) {
      this.mode = 'indeterminate';
      this.cd.detectChanges();
      window['FB'].login((response) => {
        if (response.authResponse) {
          window['FB'].api('/me', {
            fields: 'last_name, first_name, email, picture'
          }, (userInfo) => {
            let data = { email: userInfo.email, password: '', type: 'facebook' };
            let url = "user/login";
            localStorage.setItem("userEmail", userInfo.email);
            localStorage.setItem("userPass", userInfo.id);
            this.httpService.postFormData(url, data).subscribe(response => {
              if (response.success) {
                this.globalServices.isLoggedIn = true;
                response['data']['siteUrl'] = response['siteUrl'];

                localStorage.setItem('userDetails', JSON.stringify(response['data']));
                localStorage.setItem('userToken', response['token']);
                if (response['isSubscriptionPurchased']) {
                  localStorage.setItem('isSubscriptionPurchased', JSON.stringify(response['isSubscriptionPurchased']));
                }
                if (response?.data?.timezone) {
                  localStorage.setItem('timezone', JSON.stringify(response['data']["timezone"]));
                }
                this.globalServices.userDetails = JSON.parse(JSON.stringify(response['data']));
                if (JSON.parse(localStorage.getItem('cartdata')) !== null) {
                  let datum = [];
                  var a = [];
                  a = JSON.parse(localStorage.getItem('cartdata'));
                  a.forEach(el => {
                    let date = el.date.split('-');
                    let dat = {
                      type: el.portal,
                      productId: el.programId,
                      productInfo: {
                        bookingStartDate: date && date[0] ? date[0] : new Date(),
                        bookingEndDate: date && date[1] ? date[1] : new Date(),
                        accommodationId: el.accommodationId,
                        noOfPeople: el.people,
                        addonsId: el.totalAddonsId,
                      },
                      pay: el.payStatus
                    };
                    datum.push(dat);
                  });
                  const headerDict = {
                    token: localStorage.getItem('userToken')
                  };
                  let newdatum = { data: datum };

                  let Url = "billingservice/cartservice/create";
                  this.httpService.postFormDataBilling(Url, newdatum, headerDict).subscribe(response1 => {
                    localStorage.removeItem('cartdata');
                    localStorage.setItem('cartquantity', String(response1.count - 1));
                    this.globalServices.cartquantity = Number(response1.count);
                  });
                } else {
                  localStorage.setItem('cartquantity', String(response.count - 1));
                  this.globalServices.cartquantity = Number(response.count);
                }
                this.ngZone.run(() => {
                  this.loginForm.reset();
                  let userDetails = JSON.parse(localStorage.getItem("userDetails"));
                  this.globalServices.firstname = userDetails ? userDetails.firstName : '';
                  this.globalServices.imgSrc = userDetails && userDetails['images'] && userDetails['images']['path'] ? baseUrls['images'] + userDetails['images']['path'] + userDetails['images']['name'] : 'assets/images/profile-picture.png';
                  this.globalServices.subjectTriggerForLoginDetectAtHeader.next(true);
                  this.mode = 'determinate';
                  if (this.globalServices.priceCheck) {
                    this.router.navigate([this.globalServices.priceCheck['free']]);
                  }
                  else if (this.globalServices.signupPage['show']) {
                    this.globalServices.signupTriggerForSignupPage.next(true);
                    this.router.navigate(['subscribe', this.globalServices.signupPage['id'] + '-' + this.globalServices.signupPage['type']]);
                  } else {
                    this.globalServices.signupStatus = true;
                  }
                  this.globalServices.viewcontainerhelper.clear();
                })
              }
              else {
                if (response['statusCode'] === '03') {
                  this.errorMsg = response['message'];
                } else {
                  this.wrongPassword = response['message'];
                }
                this.mode = 'determinate';
                this.cd.detectChanges();
              }
            });
          });

        } else {
          this.mode = 'determinate';
          this.errorMsg = "Login failed. Please try again.";
          this.cd.detectChanges();
        }
      }, { scope: 'email' });
    }
  }

  googleSDK() {
    console.log('googleSDK_1', window['googleSDKLoaded']);
    window['googleSDKLoaded'] = () => {
      console.log('googleSDK_2', window['gapi']);
      window['gapi'].load('auth2', () => {
        this.auth2 = window['gapi'].auth2.init({
          discoveryDocs: ['https://people.googleapis.com/$discovery/rest?version=v1'],
          client_id: '968207026071-ae8fso02rfo2dhf67nb51u8auh2fm5jf.apps.googleusercontent.com',
          cookiepolicy: 'single_host_origin',
          scope: 'profile email'
        });
        this.prepareLoginButton();
      });
    }

    (function (d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { return; }
      js = d.createElement(s); js.id = id;
      js.src = "https://apis.google.com/js/platform.js?onload=googleSDKLoaded";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'google-jssdk'));

  }

  prepareLoginButton() {
    if (this.globalServices.isBrowser) {
      this.auth2.attachClickHandler(this.loginElement?.nativeElement, {},
        (googleUser) => {
          let profile = googleUser.getBasicProfile();
          gapi.client.load('https://people.googleapis.com/$discovery/rest', 'v1', this.showContacts)
        });

    }
  }

  fbLibrary() {

    (window as any).fbAsyncInit = function () {
      window['FB'].init({
        appId: '950789175432427',
        cookie: true,
        xfbml: true,
        version: 'v7.0'
      });
      window['FB'].AppEvents.logPageView();
    };

    (function (d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { return; }
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));

  }
  goTosubscription() {
    if (this.globalServices.isBrowser)
      location.href = baseUrls.global + "subscription"
  }
  // ========================google contact Search API ====================
  onSignIn = (data: any) => {

    setTimeout(() => this.fetchmail(), 1000);
  }
  fetchmail() {
    window['gapi'].load('client:auth2', () => {
      let contactInfo = window['gapi'].client.init({
        apiKey: 'AIzaSyDg_TIZFveAWrU1tq6KK-PeaWyWVzqkOrk', // API_KEY use your own
        discoveryDocs: ['https://people.googleapis.com/$discovery/rest?version=v1'],
        clientId: '968207026071-ae8fso02rfo2dhf67nb51u8auh2fm5jf.apps.googleusercontent.com',
        scope: 'profile email https://www.googleapis.com/auth/contacts.readonly'
      }).then((res) => {
        console.log('fetchmail_1', contactInfo, res);
        return window['gapi'].client.people.people.connections.list({
          resourceName: 'people/me',
          personFields: 'emailAddresses,names'
        });
      }).then(
        (res) => {
          console.log('fetchmail_2 ', contactInfo, res);
          console.log("Res: " + JSON.stringify(res)); //to debug
        },
        error => console.log("ERROR " + JSON.stringify(error))
      );

      console.log('fetchmail__fetchmail', contactInfo, contactInfo?.resources?.people?.methods?.getBatchGet(), contactInfo?.resources?.people?.methods?.listDirectoryPeople());
    });
  }
  authClick() {
    var CLIENT_ID = '968207026071-ae8fso02rfo2dhf67nb51u8auh2fm5jf.apps.googleusercontent.com';
    var SCOPES = ["https://www.googleapis.com/auth/contacts.readonly"];

    gapi.auth.authorize(
      { client_id: CLIENT_ID, scope: SCOPES, immediate: false }, this.authResult);

    return false;
  }

  /**
  * Handle response from authorization server.
  * @param {Object} authResult Authorization result.
  */
  authResult(_Result) {
    this.loadPeopleApi();
  }

  /*Load Google People client library. List Contact requested info*/
  loadPeopleApi() {
    gapi.client.load('https://people.googleapis.com/$discovery/rest', 'v1', this.showContacts);
  }

  /*Show Contacts Details display on a table pagesize = 100 connections.*/
  showContacts() {
    var request = gapi.client.people.people.connections.list({
      'resourceName': 'people/me',
      'pageSize': 100,
      'requestMask.includeField': 'person.phone_numbers,person.organizations,person.email_addresses,person.names'
    });

    request.execute(function (resp) {
      var connections = resp.connections;

      if (connections.length > 0) {
        console.log('showContacts', resp.connections)
      } else {
        console.log('showContacts_ELSE', connections, resp.connections)
      }
    });
  }
  istConnectionNames() {
    gapi.client.people.people.connections.list({
      'resourceName': 'people/me',
      'pageSize': 10,
      'personFields': 'names,emailAddresses',
    }).then(function (response) {
      console.log('istConnectionNames', response);
      var connections = response.result.connections;
    });
  }
  userCurrentPlans = [];
  getUserCurrentPlan() {
    if (this.globalServices?.isLoggedIn) {
      const userId = JSON.parse(localStorage.getItem('userDetails'))?._id;
      this.httpService.getDatabill(`billingservice/usersubscription/subs/${userId}`).subscribe((subscribePlan: any) => {
        if (subscribePlan) {
          this.userCurrentPlans = subscribePlan;
          localStorage.setItem('userSubscriptionPlan', JSON.stringify(subscribePlan))
          // 
          if (subscribePlan && subscribePlan[0]?.isExpired == 1) {
            this.globalServices.moveToPlanPage.next(true);
            localStorage.setItem('moveToPlanPage', 'true');
          }
          else {
            this.globalServices.moveToPlanPage.next(false);
            localStorage.setItem('moveToPlanPage', 'false');
          }
        }
      });
    }
  }

}

